import React, { useCallback } from 'react'

import { AIAssistantChatAssociatedAIChatbotFAQFragment } from 'types/graphql'

import CustomAnswerModal from 'src/components/AIAssistant/CustomAnswerModal'
import { useNotification } from 'src/components/shared/Notification/NotificationContext'
import useDisclosure from 'src/hooks/use-disclosure'
import LinkArea from 'src/pages/AIAssistantHistoryPage/LinkArea'
import { RefetchFnType } from 'src/types'

type Props = {
  aiChatbotFAQ: AIAssistantChatAssociatedAIChatbotFAQFragment
  refetch: RefetchFnType
  children: React.ReactNode
}

const EditCustomAnswerButton = ({ aiChatbotFAQ, refetch, children }: Props) => {
  const modalState = useDisclosure()

  const { notification } = useNotification()

  const handleSubmit = useCallback(async () => {
    notification.info({
      message: `This response has been added to your Community Assistant's Custom Answers.`,
      placement: 'bottomRight',
    })
    await refetch()
    modalState.close()
  }, [notification, refetch, modalState])

  return (
    <>
      <LinkArea cta="Edit custom answer" highlightMode="always" onClick={modalState.open}>
        {children}
      </LinkArea>
      {modalState.isOpen && (
        <CustomAnswerModal
          modalType="edit"
          aiChatbotFAQ={aiChatbotFAQ}
          onSubmit={handleSubmit}
          onClose={modalState.close}
        />
      )}
    </>
  )
}

export default React.memo(EditCustomAnswerButton)
